import React from 'react';
import { Modal } from "react-bootstrap";
import { http } from "../../helpers/http";
import { toast } from "react-toastify";
import { updateFullScreenLoader } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";


const Confirm = (props) => {
    const { openLogoutModal, setOpenLogoutModal, modalId, setModalId, card, account } = props;
    const viewCartData = useSelector((state) => state.cart?.viewCartData);
    const dispatch = useDispatch();
    const refresh = () => window.location.reload(true)

    const deleteCard = () => {
        // dispatch(updateFullScreenLoader(true));
        http({
            method: "POST",
            url: `deleteCard`,
            isSecure: true,
            body: {
                outletId: viewCartData?.dishes?.outletDetails?.outletId,
                access_token: modalId
            }
        },
            (res) => {
                if (res?.error !== "true") {
                    toast.success(res.errorMessage);
                    dispatch(updateFullScreenLoader(false));
                    setOpenLogoutModal(false);
                    refresh();

                } else {
                    toast.error("Please Select the Card");
                }
            }
        )
    }

    return (
        <Modal
            show={openLogoutModal}
            onHide={() => setOpenLogoutModal(false)}
            centered
            className="logoutmodal center-close-icon"
        >
            <Modal.Header closeButton></Modal.Header>
            <div className="bodyModal">
                <h4 className="head4 text-center mb-0 pb-0">Alert</h4>
                <div className="img-logut my-5">
                    {/* <img src="./assets/img/logoutmodal_img.png" alt="" /> */}
                </div>
                <p className="txt text-center">Are you sure you want to delete?</p>
                <div className="footerM text-center mt-4">
                    <button
                        className="cusbtn me-3 minonehunt"
                        onClick={deleteCard}
                    >
                        Yes
                    </button>
                    <button
                        className="hoverbtn minonehunt"
                        onClick={() => setOpenLogoutModal(false)}
                    >
                        No
                    </button>
                </div>
            </div>
        </Modal>
    );
};





export default Confirm;
